<style lang="stylus">
    .invitetips
        color #222222

        span
            color #FF7100
            cursor pointer
            &:hover
                text-decoration underline
</style>
<template>
    <WarnTips
        :show="showFileNumTips"
        :normalText="$t('description', { fileNum: limitFileNum })"
        :vipText="$t('tobuy')"
        :triggerStr="'cloudFileFloat'"
        @clickBuy="clickBuy"
    >
        <template #invite>
            <span v-if="showInvite" class="invitetips">
                <span @click="openInvite">{{ $t("invitebtn") }}</span>
                {{ $t("invite") }}
            </span>
        </template>
    </WarnTips>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import WarnTips from "./WarnTips.vue";

    @Component({
        components: {
            WarnTips,
        },
    })
    export default class FileNum extends Vue {
        get showFileNumTips() {
            return this.$store.getters.showFileNumTips(this);
        }
        get limitFileNum() {
            return this.$store.state.limitFileNum || 3;
        }
        count = 0;
        clickBuy() {
            if (this.count >= 3) return;
            this.count++;
            console.log(this.count);
        }
        get userInfo() {
            return this.$store.state.userInfo || this.$store.state.user.userInfo;
        }
        get showInvite() {
            return this.internal && this.count == 3;
        }
        openInvite() {
            let custom = encodeURIComponent(btoa(JSON.stringify({ id: this.userInfo.user_id, token: this.userInfo.token })));
            const url = "https://www.edrawmax.cn/useractivity/" + `?custom=${custom}`;
            window.open(url);
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "description": "非会员仅可编辑最近创建的{fileNum}个云文件（且文件未使用VIP特权），其余的仅供查看",
        "tobuy": "开通VIP",
        "invitebtn": "邀请好友",
        "invite": "可免费获得3个编辑文件，"
    },
    "en": {
        "description": "Non-premiums can only edit the {fileNum} most recently created cloud files (provided that Premium benefits were not used for these files). Other files are view-only.",
        "tobuy": "Upgrade to Premium",
        "invitebtn": "Invite new users ",
        "invite": "to get 3 extra editable documents for free."
    },
    "fr": {
        "description": "Les utilisateurs de la version gratuite peuvent uniquement modifier les {fileNum} derniers fichiers créés sur le cloud (si les avantages Premium n'ont pas été utilisés pour ces fichiers). Les autres fichiers sont en lecture seule. ",
        "tobuy": "Mise à niveau vers Edition Professional"
    },
    "de": {
        "description": "Benutzer der kostenlosen Version können nur die {fileNum} zuletzt erstellten Cloud-Dateien bearbeiten (vorausgesetzt, dass für diese Dateien keine Premium-Vorteile verwendet wurden). Andere Dateien sind schreibgeschützt.",
        "tobuy": "Auf Premium Version upgraden"
    },
    "jp": {
        "description": "無料版ユーザーは、直近に作成した{fileNum}つのクラウドファイルのみ編集できます（プレミアム特典がそのファイルに使用されていない場合）。他のファイルは表示のみ可能です。",
        "tobuy": "プロ版にアップグレード"
    },
    "es": {
        "description": "Los usuarios de la versión gratuita solo pueden editar los {fileNum} archivos en la nube creados más recientemente (siempre que no se hayan usado las ventajas Premium en estos archivos). El resto de archivos serán solo para su visualización.",
        "tobuy": "Actualizar a la versión Premium"
    },
    "pt": {
        "description": "Usuários não premium podem editar apenas os {fileNum} arquivos de nuvem criados mais recentemente (desde que os benefícios Premium não tenham sido usados para esses arquivos). Os demais arquivos são somente exibição. ",
        "tobuy": "Fazer upgrade para Versão Premium"
    },
    "it": {
        "description": "Gli utenti che non dispongono della versione Premium possono modificare solo i {fileNum} file su cloud creati più di recente (purché non abbiano utilizzato i vantaggi Premium per tali file). Gli altri file sono disponibili per la sola visualizzazione. ",
        "tobuy": "Esegui l'Upgrade alla Versione Premium"
    },
    "tw": {
        "description": "非 Premium 權益使用者只能編輯 {fileNum} 個最近建立的雲端檔案 (前提是 Premium 權益未使用於這些檔案)。其他檔案僅供檢視。",
        "tobuy": "升級VIP會員"
    },
    "kr": {
        "description": "무료 버전 사용자는 가장 최근에 생성된 {fileNum}개의 클라우드 파일만 편집할 수 있습니다(단, 이 파일에 프리미엄 혜택을 사용하지 않은 경우). 다른 파일은 보기 전용입니다.",
        "tobuy": "프리미엄으로 업그레이드"
    },
    "id": {
        "description": "Pengguna non-premium hanya dapat mengedit {fileNum} file cloud yang paling baru dibuat (dengan syarat manfaat Premium tidak digunakan untuk file ini). File lainnya hanya dapat dilihat. Tingkatkan ke Premium untuk pengeditan tanpa batas.",
        "tobuy": "Tingkatkan ke Premium"
    }
}
</i18n>
